export default "__VITE_ASSET__DKwafvuW__"